export default __webpack_public_path__ + "static/mediasobrebarriga-8555da8f05fe0a0d3f44158fbd3a8cb3.jpg";